import * as CookieConsent from 'vanilla-cookieconsent';
import { de } from './consent-manager/de';

const language = document.documentElement.lang.substring(0, 2);

window.CookieConsent = CookieConsent;

CookieConsent.run({
    mode: 'opt-in',
    autoShow: true,
    revision: 0,
    manageScriptTags: true,
    disablePageInteraction: false,

    cookie: {
        name: 'privacy_preferences',
        domain: window.location.hostname,
        path: '/',
        expiresAfterDays: 365,
        sameSite: 'Lax',
    },

    guiOptions: {
        consentModal: {
            layout: 'cloud inline',
            position: 'bottom center',
            flipButtons: false,
            equalWeightButtons: true,
        },
        preferencesModal: {
            layout: 'box',
            position: 'left',
            flipButtons: false,
            equalWeightButtons: true,
        },
    },

    categories: {
        necessary: {
            enabled: true,
            readOnly: true,
        },
        analytics: {
            enabled: true,
            readOnly: true,
            autoClear: {
                cookies: [/^_pk_/],
                reloadPage: true,
            },
            services: {
                matomo: {
                    label: 'Matomo',
                },
            },
        },
        marketing: {
            autoClear: {
                cookies: [
                    /^ONE_SIGNAL/,
                    /^ONESIGNAL/,
                    /^onesignal/,
                    'os_pageViews',
                    'isOptedOut',
                    'isPushNotificationsEnabled',
                ],
                reloadPage: true,
            },
            services: {
                onesignal: {
                    label: 'OneSignal',
                },
            },
        },
        media: {
            autoClear: {
                cookies: [],
                reloadPage: true,
            },
            services: {
                mapbox: {
                    label: 'Mapbox',
                },
                youtube: {
                    label: 'YouTube',
                },
                vimeo: {
                    label: 'Vimeo',
                },
                podigee: {
                    label: 'Podigee',
                },
            },
        },
    },

    language: {
        default: 'de',
        autoDetect: 'document',
        translations: {
            de,
        },
    },
});
